import _get from 'lodash/get';
import { a as _objectSpread } from '../chunk-ad6ad343.js';

var Page = function Page(overrides) {
  return _objectSpread({
    collapseBreakpoint: 'desktop'
  }, _get(overrides, 'Page', {}), {
    WithSidebar: _objectSpread({
      minimizedSidebarWidth: '60px',
      sidebarWidth: '250px'
    }, _get(overrides, 'Page.WithSidebar', {}))
  });
};

export default Page;